// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__Ys0yW","footer":"NavbarSimple_footer__nLcX8","link":"NavbarSimple_link__J1z5v","linkIcon":"NavbarSimple_linkIcon__+vPde"};